import { Button } from 'components/button/Button'
import { SButtonsWrapper } from './CreateSPActions.styled'
import { Icon } from 'components/icon'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'utils/hooks'

export function CreateSPActions(props: {
  className?: string
  onTakeSelfiePress: () => void
  onUploadPhotoPress: () => void
}) {
  const { t } = useTranslation('memory')
  const { isDesktop } = useWindowSize()

  return (
    <SButtonsWrapper className={props?.className}>
      <Button
        type="button"
        size="large"
        tone="accent"
        leftIcon={<Icon name="Camera" />}
        onClick={props.onTakeSelfiePress}
      >
        {isDesktop
          ? t('memory.singing.take_selfie_button_desktop')
          : t('memory.singing.take_selfie_button_mobile')}
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="large"
        tone="dark"
        onClick={props.onUploadPhotoPress}
        leftIcon={<Icon name="FileUpload" />}
      >
        {isDesktop
          ? t('memory.singing.upload_photo_button_desktop')
          : t('memory.singing.upload_photo_button_mobile')}
      </Button>
    </SButtonsWrapper>
  )
}
